module.exports = __webpack_public_path__ + "img/iomico_logo_2.7d7ec7f3.svg";